module.exports = __webpack_public_path__ + "static/media/seen.ab4d270d.svg";